import React from "react";

function TableHeader() {
  return (
    <>
      <tr className="request__table">
        <td height="17" bgcolor="#CCFFFF" align="left">
          ΑΙΤΟΥΣΑ ΜΟΝΑΔΑ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          96ΤΜΧΕΘ/ΔΡΙΑ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="center">
          ΜΟΝΑΔΑ ΜΕΣΩ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          ΔΓΗ ΧΟΡΗΓΗΣΗΣ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          ΔΙΑΤΑΓΗ ΔΕΣΜΕΥΣΗΣ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <font size="1">
            <br />
          </font>
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
      </tr>
      <tr>
        <td height="17" bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="center">
          ή
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <font size="1">
            <br />
          </font>
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
      </tr>
      <tr>
        <td height="17" bgcolor="#CCFFFF" align="left">
          ΧΟΡΗΓΟΥΣΑ ΜΟΝΑΔΑ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          96 ΤΥΠΕΘ ΛΥΠ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="center">
          ΜΟΝΑΔΑ ΔΙΑ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          ΚΩΔΙΚΑΣ ΔΙΑΤΑΓΗΣ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          ΚΩΔΙΚΑΣ ΔΙΑΤΑΓΗΣ
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <font size="1">
            <br />
          </font>
        </td>

        <td bgcolor="#CCFFFF" align="left">
          <font size="1">
            <br />
          </font>
        </td>
      </tr>
      <tr>
        <td height="17" bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="center">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <font size="1">
            <br />
          </font>
        </td>
        <td bgcolor="#CCFFFF" align="left">
          <br />
        </td>
      </tr>
      <tr>
        <td height="17" align="left">
          <br />
        </td>
        <td align="left">
          <br />
        </td>
        <td align="left">
          <br />
        </td>
        <td align="left">
          <br />
        </td>
        <td align="center">
          <br />
        </td>
        <td align="left">
          <br />
        </td>
        <td align="left">
          <br />
        </td>
        <td align="left">
          <br />
        </td>
        <td align="left">
          <br />
        </td>
        <td align="left">
          <br />
        </td>
        <td align="left">
          <font size="1">
            <br />
          </font>
        </td>
        <td align="left">
          <br />
        </td>
      </tr>
      <tr className="request__table header-row">
        <td>ΚΩΔΙΚΑΣ ΕΝΤΥΠΟΥ</td>
        <td>ΑΡΙΘΜΟΣ ΟΝΟΜΑΣΤΙΚΟΥ</td>
        <td>Part Number</td>
        <td>Ονομασία</td>
        <td>ΚΥΡΙΟ ΥΛΙΚΟ</td>
        <td>ΑΙΤΟΥΜΕΝΗ ΠΟΣΟΤΗΤΑ</td>
        <td>ΤΑΥΤΟΤΗΤΑ ΕΝΤΥΠΟΥ</td>
        <td>ΜΜ</td>
        <td>ΑΙΤΙΟΛΟΓΙΑ</td>
        <td>ΠΡΟΤΕΡΑΙΟΤΗΤΑ</td>
        <td>ΔΕΛΤΙΟ</td>
        <td>Όχημα</td>
      </tr>
    </>
  );
}

export default TableHeader;
